import { render, staticRenderFns } from "./PageBIPerformance.vue?vue&type=template&id=78be8d54"
import script from "./PageBIPerformance.vue?vue&type=script&lang=js"
export * from "./PageBIPerformance.vue?vue&type=script&lang=js"
import style0 from "./PageBIPerformance.vue?vue&type=style&index=0&id=78be8d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports